var lib_core = require("lib-core");
var ContentServerMetaData = require("../contentServerMetaData.js");
var Properties = require("cio-config").MetaProperties;

var FootprintMetaData = function () {
    ContentServerMetaData.call(this);

    for(var key in Properties["footprint"]){
        if(Properties["footprint"].hasOwnProperty(key))
            this[key] = this.value(key, true);
    }
    
};
lib_core.inherit(FootprintMetaData, ContentServerMetaData);
lib_core.JsonParser.registerClass(FootprintMetaData, "FootprintMetaData");

module.exports = FootprintMetaData;

FootprintMetaData.prototype.assetType = function () {
	return "footprint";
};

FootprintMetaData.prototype.assetPath = function () {
	return "footprints/";
};
